"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var material_1 = require("@mui/material");
var AlertItem_1 = require("../../theme/layout/cards/AlertItem");
var NotificationList = function (_a) {
    var data = _a.data, selectedAlertIds = _a.selectedAlertIds, setSelectedAlertIds = _a.setSelectedAlertIds, DrawerComponent = _a.DrawerComponent;
    var _b = (0, react_1.useState)(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = (0, react_1.useState)(''), currentAlertId = _c[0], setCurrentAlertId = _c[1];
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ divider: (0, jsx_runtime_1.jsx)(material_1.Divider, { orientation: "horizontal", flexItem: true }) }, { children: [data.map(function (item) {
                return ((0, jsx_runtime_1.jsx)(AlertItem_1.AlertItem, { uuid: item.uuid, riskScore: item.risk_score, title: item.title, timeCreated: item.time_created, onPress: function () {
                        setCurrentAlertId(item.uuid);
                        setIsOpen(true);
                    }, selected: selectedAlertIds.includes(item.uuid), onCheckboxPress: function (e) {
                        e.stopPropagation();
                        if (selectedAlertIds.includes(item.uuid)) {
                            setSelectedAlertIds(selectedAlertIds.filter(function (id) { return id !== item.uuid; }));
                        }
                        else {
                            setSelectedAlertIds(__spreadArray(__spreadArray([], selectedAlertIds, true), [item.uuid], false));
                        }
                    }, isBulkSelectMode: selectedAlertIds.length > 0, showDeviceName: false, Link: null }, item.uuid));
            }), (0, jsx_runtime_1.jsx)(DrawerComponent, { isOpen: isOpen, setIsOpen: setIsOpen, alertId: currentAlertId })] })));
};
exports.default = NotificationList;
